const dict = {
  chooseLang: "Sprache wählen",
  agree: "Zustimmen",

  //Licence
  instructions: "Anleitung",
  step1: "Schritt 1: QR-Code scannen",
  locateqr: "Suchen Sie den QR-Code auf Ihrer rechten Seite.",
  useSmartphone:
    "Verwenden Sie die Kamera Ihres Smartphones oder eine QR-Scanner-App, um ihn zu scannen. Dies führt Sie zum nächsten Schritt.",
  step2: "Schritt 2: Playlist-Informationen eingeben",
  afterScan: "Nach dem Scannen des QR-Codes werden Sie aufgefordert, Ihre Playlist-Informationen einzugeben.",
  makeSure: "Stellen Sie sicher, dass alle erforderlichen Felder ausgefüllt sind.",
  step3: "Schritt 3: Zur App zurückkehren",
  onceYou:
    "Nachdem Sie Ihre Playlist-Details eingegeben haben, können Sie zur App zurückkehren und Ihr Erlebnis fortsetzen.",
  refresh: "AKTUALISIEREN",
  playlist: "Playlist",
  bigPlaylist: "PLAYLISTS",
  noLicence: "Sie haben keine Lizenz.",
  scanLicence: "Scannen Sie, um eine Lizenz zu kaufen.",
  noPlaylist: "Sie haben keine Playlist",
  privacyBig: "DATENSCHUTZMODUS",
  scanToAddBig: "SCANNEN UM PLAYLIST HINZUZUFÜGEN",
  scanToBuyBig: "SCANNEN UM LIZENZ ZU KAUFEN",
  orVisit: "oder besuchen Sie",
  andenterdeviceID: "und geben Sie diese Geräte-ID ein:",
  removePlaylist: "Playlist entfernen",
  wantToRemove: "Möchten Sie entfernen?",
  cancelBig: "ABBRECHEN",
  loading: "Laden...",
  enablePMode: "Bitte aktivieren Sie den Datenschutzmodus, um weiter zu schauen.",
  killSwitchProtecting: "Der Kill Switch schützt Ihre Privatsphäre, indem er den Zugang blockiert, wenn der Datenschutzmodus deaktiviert ist.",
  kSwitchProtecionActive: "Kill Switch Schutz Aktiv",
  privacyMode: "Datenschutzmodus",
  ok: "OK",

  //Home
  bigLiveTv: "Live-TV",
  bigMovies: "Filme",
  bigSeries: "Serien",
  //Channel-Menu
  noChannels: "Diese Playlist enthält keine Kanaldaten",
  searchChannels: "Kanal suchen",
  tapToPlay: "Tippen Sie, um den Videostream abzuspielen.",
  categoryEmpty: "Diese Kategorie ist leer",
  pinNotSet: "PIN nicht festgelegt",
  setPinNow: " Möchten Sie Ihren PIN jetzt einrichten?",
  preview: "VORSCHAU",
  liveTv: "Live-TV",
  addToFav: "Zu Favoriten hinzufügen",
  removeFromFav: "Aus Favoriten entfernen",
  now: "Jetzt:",
  nextPlaying: "Als nächstes:",
  channels: "Kanäle",
  noChannelsFound: "Keine Kanäle gefunden",

  //Movies
  noMovies: "Diese Playlist enthält keine Filmdaten",
  searchMovies: "Filme suchen",
  noFavMovies: "Keine Lieblingsfilme",
  //series
  noSeries: "Diese Playlist enthält keine Seriendaten",
  searchSeries: "Serien suchen",
  noFavSeries: "Keine Lieblingsserien",
  search: " Suchen",
  thereIsProblem: "Es gibt gerade ein Problem",
  tryAgainLater: "Bitte versuchen Sie es später erneut.",
  series: "Serien",
  movies: "Filme",
  noSeriesFound: "Keine Serien gefunden",
  noMoviesFound: "Keine Filme gefunden",
  //entity
  play: "ABSPIELEN",
  playMovie: "Film abspielen",
  recommendations: "Empfehlungen",
  //User Info
  userInfo: "Benutzerinformationen",
  aboutApp: "Über die App",
  //Userinfo
  account: "Konto",
  subscriptions: "Abonnements",
  privacyPilicy: "Datenschutz & Richtlinie",
  languge: "Sprache",
  english: "Englisch",
  italian: "Italienisch",
  german: "Deutsch",
  spanish: "Spanisch",
  french: "Französisch",
  saudiArabia: "Arabisch",
  chinese: "Chinesisch",
  greek: "Griechisch",
  turkish: "Türkisch",
  change_pin: "PIN ändern",
  kill_switch: "Kill Switch",
  device_info: "Geräteinformationen",
  unknown: "Unbekannt",

  //headers
  settings: "Einstellungen",
  termsConditions: "Allgemeine Geschäftsbedingungen",
  home: "Startseite",

  //license
  scanQrCode: "QR-Code scannen, um eine Playlist zu senden",
  managePlaylist: "Playlist verwalten",
  orVisitt: "Oder besuchen Sie",
  scanToAdd: "Scannen Sie, um eine Playlist hinzuzufügen, oder besuchen Sie",

  //device info
  display: "Anzeige",
  storage: "Speicher",
  network: "Netzwerk",
  connection: "Verbindung",
  macAddress: "MAC-Adresse:",
  deviceId: "Geräte-ID:",
  pmInfo: "Informationen zum Datenschutzmodus",
  statusActive: "Status: Aktiv",
  underMaintance: "Status: In Wartung",
  version: "Version:",
  lastBuildDate: "Letztes Build-Datum:",
  lastUpdated: "Zuletzt aktualisiert: ",

  //kill switch
  enableKillSwitch: "Kill Switch aktivieren?",
  disableKillSwitch: "Kill Switch deaktivieren?",
  whenEnabled: "Wenn aktiviert, funktioniert OrbixPlay NUR, wenn der Datenschutzmodus eingeschaltet ist.",
  withOrWithoutPM: "OrbixPlay funktioniert normal mit oder ohne Datenschutzmodus.",
  extra_privacy_protection: " Zusätzlicher Datenschutz",
  pmOn: "• Wenn der Datenschutzmodus EIN ist: können Sie Inhalte sicher streamen",
  killSwitchDescription: "Der Kill Switch bietet eine zusätzliche Schutzschicht für maximale Privatsphäre.",
  pmOff: "• Wenn der Datenschutzmodus AUS ist: blockiert die App den Zugang, um Ihre Privatsphäre zu schützen",
  reenable: "Sie können ihn jederzeit für maximale Sicherheit wieder aktivieren.",
  cancel: "Abbrechen",
  enable: "Aktivieren",
  disable: "Deaktivieren",
  killSwitch: "Kill Switch – Zusätzlicher Datenschutz",
  ipHidden: "Wenn Sie den Datenschutzmodus aktivieren, wird Ihre IP-Adresse verborgen und Ihre Verbindung läuft über ein sicheres System — ähnlich wie ein VPN funktioniert.",
  extraLayer: "Der Kill Switch ist eine zusätzliche Schutzschicht: Wenn Sie ihn aktivieren, funktioniert OrbixPlay nur, wenn der Datenschutzmodus eingeschaltet ist.",
  ifPmOn: "• Wenn der Datenschutzmodus EIN ist: können Sie Inhalte sicher streamen",
  ifPmOff: "• Wenn der Datenschutzmodus AUS ist: blockiert die App den Zugang, um Ihre Privatsphäre zu schützen",
  recommended: "Empfohlen für alle, die maximale Sicherheit wollen und niemals ohne Schutz streamen möchten.",
  current_status: "Aktueller Status:",
  pressToDisable: "🛡️ AKTIVIERT - Drücken zum Deaktivieren",
  pressToEnable: "○ DEAKTIVIERT - Drücken zum Aktivieren",
  pressEnter: " Drücken Sie Enter auf der Schaltfläche oben, um die Kill Switch Einstellung zu ändern",

  //set pin
  pinSetSuccessfully: "PIN erfolgreich festgelegt!",
  createPin: "Erstellen Sie Ihren PIN",
  confirmPin: "Bestätigen Sie Ihren PIN",
  confirmYourPin: "confirmPin: 'Bestätigen Sie Ihren PIN'",
  initializingPin: "PIN-Einrichtung wird initialisiert...",
  enterCurrentPin: "Aktuellen PIN eingeben",
  enterNewPin: "Neuen PIN eingeben",
  confirmNewPin: "Neuen PIN bestätigen",
  pinChanged: "PIN erfolgreich geändert!",
  pinHasChanged: " Ihr PIN wurde erfolgreich geändert!",

  //lastones
  playInfo: "Playlist-Informationen",
  playName: "Playlist-Name:",
  host: "Host:",
  username: "Benutzername:",
  password: "Passwort:",
  packName: "Paketname:",
  expireDate: "Ablaufdatum:",

  //privacyPolicy
  one: "1. Haftungsausschluss für Inhalte: OrbixPlay ist eine Plattform, die darauf ausgelegt ist, Ihr digitales Erlebnis zu verbessern. Es ist jedoch wichtig zu beachten, dass OrbixPlay keine Videoinhalte hostet, bereitstellt oder verteilt. Unser Service ist darauf ausgerichtet, Ihre digitale Reise zu unterstützen, aber wir übernehmen keine Verantwortung für die Verfügbarkeit, Qualität oder den Inhalt von Videomaterial, da dies außerhalb des Rahmens unserer Dienste liegt.",
  two: "2. Keine Haftung für Inhalte Dritter: OrbixPlay LLC haftet nicht für Inhalte Dritter, auf die Sie möglicherweise über unsere Anwendung zugreifen. Ihr Umgang mit externen Inhalten, einschließlich deren Rechtmäßigkeit, Zuverlässigkeit oder Angemessenheit, erfolgt ausschließlich auf Ihr eigenes Risiko.",
  three:
    "3. Zuständigkeit und Compliance: OrbixPlay LLC operiert unter der Zuständigkeit der Vereinigten Staaten. Die Nutzer sind dafür verantwortlich sicherzustellen, dass ihre Nutzung der Anwendung allen lokalen, staatlichen und bundesstaatlichen Gesetzen entspricht.",
  four: "4. Preispolitik: Die Preise für die Dienste von OrbixPlay können jederzeit ohne vorherige Ankündigung geändert werden. Durch die Annahme dieser Vereinbarung erkennen Sie an und stimmen zu, dass die Preise variieren können und dass solche Änderungen Ihren aktuellen Service bis zur Erneuerung Ihres Abonnements nicht beeinflussen werden.",
  five: `5. Keine Garantie: Die OrbixPlay-Anwendung und ihre Dienste werden „wie besehen" ohne ausdrückliche oder stillschweigende Garantien bereitgestellt, einschließlich, aber nicht beschränkt auf stillschweigende Garantien der Marktgängigkeit, Eignung für einen bestimmten Zweck und Nichtverletzung.`,
  six: "6. Annahme der Bedingungen: Durch Klicken auf Zustimmen erklären Sie sich damit einverstanden, an die Bedingungen dieses Haftungsausschlusses gebunden zu sein, und erkennen an, dass jeder Verstoß zur Kündigung Ihres Zugangs zu den OrbixPlay-Diensten führen kann.",
  orbixUserAgreement: "ORBIXPLAY NUTZERVEREINBARUNG UND HAFTUNGSAUSSCHLUSS",
  beforeyouProcc: "Bevor Sie fortfahren, lesen und akzeptieren Sie bitte die folgenden Allgemeinen Geschäftsbedingungen:",

  //additional
  exitApp: "OrbixPlay beenden",
  wantToExit: "Sind Sie sicher, dass Sie OrbixPlay beenden möchten?",
  Resume: "Fortsetzen",

  whatsnewinv: "Neues in Version v",
  whatsnew: "Neuigkeiten",

  resellerInfiniteDevices: "Reseller-Plan: Unbegrenzte Geräte",
  resellerInfiniteDevicesDesc: "Dieselbe Playlist kann jetzt auf unbegrenzt vielen Geräten installiert werden — nicht nur 5 oder 10, sondern so viele Sie möchten.",
  thankyouforusingorbixplayenjoythenewfeatures: "Danke, dass Sie OrbixPlay nutzen — viel Freude mit den neuen Funktionen!",

  instanthomescreen: "Weiterschauen",
  instanthomescreendesc: "Setzen Sie Ihre Serien und Filme genau dort fort, wo Sie aufgehört haben.",
  turbomoviesearch: "Favoriten-Funktion",
  turbomoviesearchdesc: "Speichern Sie Ihre Lieblingsinhalte für schnellen und einfachen Zugriff jederzeit.",
  lighterondataandbattery: "Verbesserte Player-Stabilität",
  lighterondataandbatterydesc: "Verbesserte Wiedergabezuverlässigkeit und flüssigere Suchvorgänge.",
  underthehoodfixes: "Interne Korrekturen",
  underthehoodfixesdesc: "Verschiedene Fehlerbehebungen und Leistungsverbesserungen für ein besseres Erlebnis.",

  proxyMaintenance: 'Proxy-Wartung',
  proxyMaintenanceMessage: 'Der Proxy-Server befindet sich derzeit in Wartung. Bitte versuchen Sie es später erneut.',

  playlistInformation: 'Playlist-Informationen',
  playlistExpDate: 'Ablaufdatum der Playlist: ',

  select_playlist: "Playlist auswählen",
  choose_playlist: "Wähle eine Playlist, um mit dem Ansehen zu beginnen",
  invalid_line: "Ungültige Zeile",
  expire_date: "Ablaufdatum:",
  expired: "Abgelaufen",
  waiting_connection: "Warte auf Verbindung...",
  reconnection_attempt: "Wiederverbindungsversuch",
  try_again: "Erneut versuchen",
  go_back: "Zurück",
  unable_to_resume: "Fortsetzen nicht möglich",
  reconnecting: "Verbindung wird wiederhergestellt...",
  no_internet_connection: "Keine Internetverbindung",
  please_try_again: "Stream konnte nicht neu gestartet werden. Bitte versuche es erneut.",
  restore_stream: "Bitte warte, während wir deinen Stream wiederherstellen.",
  reconnect_automatically: "Überprüfe dein Netzwerk und wir verbinden uns automatisch erneut.",
  check_wifi: "Überprüfe deine WLAN-Verbindung",
  check_ethernet: "Überprüfe deine Ethernet-/LAN-Verbindung",
  check_internet: "Überprüfe deine Internetverbindung",

  add_playlist_screen: "Playlist hinzufügen",
  add_playlist: "Playlist manuell hinzufügen",
  playlist_name_required: "Playlist-Name ist erforderlich",
  m3u_url_required: "M3U-Playlist-URL ist erforderlich",
  server_url_required: "Server-URL ist erforderlich",
  username_required: "Benutzername ist erforderlich",
  password_required: "Passwort ist erforderlich",
  orbix_code_required: "Orbix-Host-Code ist erforderlich",
  list_code_required: "Listencode ist erforderlich",
  device_id_required: "Geräte-ID ist erforderlich",
  device_id: "Geräte-ID : ",
  playlist_format: "Playlist-Format",
  m3u: "M3U-URL",
  username_password: "Benutzername / Passwort",
  orbix_code: "Orbix-Code",
  list_code: "Listencode",
  playListName: "Playlist-Name *",
  m3uUrl: "M3U-Playlist-URL *",
  server_URL: "Server-URL *",
  username_req: "Benutzername *",
  password_req: "Passwort *",
  orbix_code_req: "Orbix-Host-Code *",
  list_code_req: "Listencode *",
  addPlaylist: "Playlist hinzufügen",
  adding: "Wird hinzugefügt...",
  my_playlist: "Meine Playlist",
  username_placeholder: "benutzername",
  password_placeholder: "••••••••",

  //stream exceptions
  stream_extension: "Stream-Erweiterung",

  //storage_and_data
  storage_and_data: "Speicher & Daten",

  // ── Parental PIN ──────────────────────────────────────────────────────────
  enter_parental_pin: "Eltern-PIN eingeben",

  // ── Account / Subscriptions labels ───────────────────────────────────────
  status: "Status",
  active: "Aktiv",
  expiration: "Ablauf",
  max_connections: "Max. Verbindungen",
  one_device: "1 Gerät",
  created: "Erstellt",

  // ── Storage & Data screen ─────────────────────────────────────────────────
  section_title: "Speicher & Daten",
  section_subtitle: "Gespeicherte App-Daten verwalten",
  favourites_label: "Favoriten",
  history_label: "Wiedergabe-Verlauf",
  cleared_label: "Geleert",
  all_cleared_label: "Alles geleert",
  remove_cancel_label: "Abbrechen",
  remove_confirm_label: "Leeren",
  clear_fav_channels_title: "Lieblingskanäle",
  clear_fav_channels_subtitle: "Alle gespeicherten Kanäle entfernen",
  clear_fav_channels_message: "Alle Lieblingskanäle löschen?",
  clear_fav_movies_title: "Lieblingsfilme",
  clear_fav_movies_subtitle: "Alle gespeicherten Filme entfernen",
  clear_fav_movies_message: "Alle Lieblingsfilme löschen?",
  clear_fav_series_title: "Lieblingsserien",
  clear_fav_series_subtitle: "Alle gespeicherten Serien entfernen",
  clear_fav_series_message: "Alle Lieblingsserien löschen?",
  clear_continue_watching_movies_title: "Weiterschauen – Filme",
  clear_continue_watching_movies_subtitle: "Film-Fortschritt entfernen",
  clear_continue_watching_series_title: "Weiterschauen – Serien",
  clear_continue_watching_series_subtitle: "Serien-Fortschritt entfernen",
  clear_continue_watching_title: "Weiterschauen",
  clear_continue_watching_message: "Wiedergabeverlauf löschen?",
  clear_all_title: "Alle Daten löschen",
  clear_all_message: "Dies löscht alle Favoriten und den Verlauf.",

  // ── Stream Extension screen ───────────────────────────────────────────────
  stream_extension_desc: "Wählen Sie, wie Live-Streams vom Server angefordert werden.",
  ts_desc: "Standard-MPEG-TS-Stream",
  m3u8_desc: "HLS-Adaptivstream",
  current: "Aktuell",

  // ── Kill Switch modal ─────────────────────────────────────────────────────
  access_restricted: "🛡️ Zugriff eingeschränkt",
  to_access_playlists: "So greifen Sie auf Playlists zu:",
  enable_privacy_mode_step: "1. Datenschutzmodus über den Hauptbildschirm aktivieren",
  disable_kill_switch_step: "2. Oder Kill Switch in Einstellungen → Kill Switch deaktivieren",
  preparingContent: "Inhalte werden vorbereitet",

  // ── Home screen ──────────────────────────────────────────────────────────────
  loading_base: "Laden",
  live_now: "JETZT LIVE",
  news: "NACHRICHTEN",
  sport: "SPORT",
  kids: "KINDER",

  // ── Series details ───────────────────────────────────────────────────────────
  episode: "Episode",
  no_episodes: "Für diese Staffel sind keine Episoden verfügbar.",

  searchForChannels: "Kanäle suchen...",
  kbSpace: "Leertaste",
  kbCaps: "Großschrift",
  pressOkToPlay: "OK drücken zum Abspielen",
  live: "Live",
};

export default dict;